/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselPrint_item = {
    readonly isMultiSku: boolean;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
    } | null> | null;
    readonly sortedPhotos: ReadonlyArray<{
        readonly largePath: string | null;
        readonly sortOrder: number | null;
        readonly imageSkuXrefs: ReadonlyArray<{
            readonly skuId: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "PdpRespHeroCarouselPrint_item";
};
export type PdpRespHeroCarouselPrint_item$data = PdpRespHeroCarouselPrint_item;
export type PdpRespHeroCarouselPrint_item$key = {
    readonly " $data"?: PdpRespHeroCarouselPrint_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselPrint_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselPrint_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "sortedPhotos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSkuXref",
          "kind": "LinkedField",
          "name": "imageSkuXrefs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skuId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '0a0097c0f971519639f20bad8abb59bc';
export default node;
